import { render, staticRenderFns } from "./NinaCardBack.vue?vue&type=template&id=18a558b7&"
import script from "./NinaCardBack.vue?vue&type=script&lang=js&"
export * from "./NinaCardBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports